import * as Yup from 'yup';

export const DisplayingErrorMessagesSchema = Yup.object().shape({
    password: Yup.string().required('validation.required').matches(/^.*(?=.{8,})(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!-\/:-@[-`{-~]).*)$/, 'validation.pwdInvalid'),
    password_confirmation: Yup.string().required('validation.required').required('validation.required').oneOf([Yup.ref('password'), null], 'validation.cnfPwdInvalid'),
});
